import {
  TargetEntity,
  TargetEntityDetails,
} from '~/features/x-ray/types/entity';
import { intlService } from '~/i18n/IntlService';

import { getFields } from '../fields/getFields';

interface Request {
  entity: TargetEntity;
}

export const resolvePromptModelTargetEntityDetails = async ({
  entity,
}: Request): Promise<TargetEntityDetails> => {
  const { id, type } = entity;
  switch (type) {
    case 'field': {
      const { results } = await getFields({ ids: [Number(id)] });
      const field = results[0];
      if (!field) {
        throw new Error(
          intlService.getIntl().formatMessage({
            id: 'resolvePromptModelTargetEntityDetails.fieldNotFound',
            defaultMessage: 'Field not found or has an unsupported type',
            description:
              'Error message when a field is missing or its type cannot be resolved',
          }),
        );
      }
      return {
        id: String(field.id),
        label: field.label,
        type,
      };
    }
    default:
      throw new Error(
        intlService.getIntl().formatMessage({
          id: 'resolvePromptModelTargetEntityDetails.entityTypeNotSupported',
          defaultMessage: 'Entity type not supported',
          description: 'Error message when entity type is not supported',
        }),
      );
  }
};
